<template>

	<div class="index-body">
		<img class="wenzi" src="../assets/wenzi.png" alt="">
		<div class="index-title">
			<p class="year" >{{form.Year}}</p>
			<p class="area" :style="{fontSize:form.TitleSize+'px'}">{{form.Title}}</p>
			<p :style="{fontSize:form.SubtitleSize+'px'}">{{form.Subtitle}}</p>
			<button @click="Contestentry()">大赛入口</button>
		</div>
		<div class="time">
			<p>{{form.CurrentTimeDescript}}</p>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				current: 1,
				form:Object,
			};
		},
		created() {
    this.GetSiteSetting()
		},
		methods:{
			GetSiteSetting() {
				this.axios.get('/api/SiteSetting/GetSiteSetting')
				.then(response => {
			    console.log(response)
			    this.form = response.data.data
				}).catch(error => {
					console.log(error)
				})
			},
			Contestentry(){
				this.$router.push('/introduce')
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.index-body {
		position: relative;
		background: url("../assets/index.jpg") no-repeat center center;
		background-size: cover;
		min-height: calc(100vh - 120px);
		text-align: center;

		.wenzi {
			width: 900px;
			margin-top: 8%;
		}

		.index-title {
			width: 1100px;
			margin: 0 auto;
			.year {
				font-size: 40px;
			}

			.area {
				font-size: 45px;
				font-weight: bold;
				margin: 20px 0;
			}

			button {
				background: #ab885b;
				color: #fff;
				border: #ab885b;
				padding: 5px 35px;
				font-size: 18px;
				border-radius: 6px;
				margin-top: 30px;
			}
		}

		.time {
			position: absolute;
			bottom: 30px;
			left: 0;
			width: 100%;

			p {
				width: 900px;
				text-align: left;
				margin: 0 auto;
				font-weight: bold;
				font-size: 16px
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/main.vue